// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

// Types
import { IRootState } from './type';

const initialState: IRootState = {
  registeredUser: {} as IRootState['registeredUser'],
  isOpenPricingNav: false,
  inviteMembers: [],
};
export const slice = createSlice({
  name: STORE_SLICES.ONBOARDING,
  initialState,
  reducers,
});
const onboardingActions = slice.actions;

const onboardingPersistConfig = {
  key: PERSIST_KEYS.ONBOARDING,
  storage,
  whitelist: ['registeredUser', 'inviteMembers'],
};

export {
  onboardingActions,
};

export default persistReducer(onboardingPersistConfig, slice.reducer);
